import 'phaser';

export default function getConfig() {
  return {
    type: Phaser.AUTO,
    parent: 'game-container',
    width: 1280,
    height: 720,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    backgroundColor: 0xffffff,
    scene: [],
    dom: {
      createContainer: true,
    },
    zoom: 1,
    fps: { target: 60 },
    physics: {
      default: 'arcade',
    },
    audio: {
      disableWebAudio: false,
    },
  };
}
